module.exports = __webpack_public_path__ + "assets/celebration-0f3cb0.svg";